var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_641_12177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 0L19.9979 3.85714V5.14286H18.6649C18.6649 5.31696 18.5937 5.46763 18.4514 5.59487C18.3091 5.7221 18.1407 5.78571 17.9463 5.78571H2.05401C1.85961 5.78571 1.69124 5.7221 1.54891 5.59487C1.40658 5.46763 1.33542 5.31696 1.33542 5.14286H0.00238037V3.85714L10.0002 0ZM2.66845 6.42857H5.33453V14.1429H6.66757V6.42857H9.33364V14.1429H10.6667V6.42857H13.3328V14.1429H14.6658V6.42857H17.3319V14.1429H17.9463C18.1407 14.1429 18.3091 14.2065 18.4514 14.3337C18.5937 14.4609 18.6649 14.6116 18.6649 14.7857V15.4286H1.33542V14.7857C1.33542 14.6116 1.40658 14.4609 1.54891 14.3337C1.69124 14.2065 1.85961 14.1429 2.05401 14.1429H2.66845V6.42857ZM19.2793 16.0714C19.4737 16.0714 19.6421 16.135 19.7844 16.2623C19.9268 16.3895 19.9979 16.5402 19.9979 16.7143V18H0.00238037V16.7143C0.00238037 16.5402 0.0735451 16.3895 0.215875 16.2623C0.358204 16.135 0.526569 16.0714 0.720971 16.0714H19.2793Z",
    fill: "#000080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_641_12177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedNotification);
export default __webpack_public_path__ + "static/media/verified_notification.2a815f83aa63c871ba152492859cbb24.svg";
export { ForwardRef as ReactComponent };